// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FK-z","smallCardRow":"GK-z","largeCardRow":"HK-z","productSearchRow":"IK-z","curatedRow":"JK-z"};